import { ref, onMounted } from 'vue';
import { useForm } from '@/views/login/index';
import { useRouter } from 'vue-router';
import Swal from 'sweetalert2';
import { getUser, clearUser, setUserFromToken } from '@/store/userStore';
import { toggleMobileSidebar } from '@/store/uiStore';
export default {
    name: 'Header',
    setup() {
        const { showSignIn, showSignUp } = useForm();
        const router = useRouter();
        const user = ref(null);
        onMounted(() => {
            user.value = getUser();
            if (!user.value) {
                const token = localStorage.getItem('accessToken');
                if (token) {
                    setUserFromToken(token);
                    user.value = getUser();
                }
            }
        });
        function goToHome() {
            router.push('/');
        }
        function goToLogin() {
            router.push('/login');
            showSignIn();
        }
        function goToRegister() {
            router.push('/login');
            showSignUp();
        }
        function logout() {
            Swal.fire({
                title: '¿Estás seguro?',
                text: 'Tu sesión será cerrada.',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'swal-button--confirm-custom',
                    cancelButton: 'swal-button--cancel-custom'
                },
                confirmButtonText: 'Sí, cerrar sesión',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    clearUser();
                    user.value = null;
                    router.push('/').then(() => {
                        window.location.reload();
                    });
                }
            });
        }
        function toggleMenu() {
            toggleMobileSidebar();
        }
        return {
            user,
            goToHome,
            goToLogin,
            goToRegister,
            logout,
            toggleMenu
        };
    },
};
